export default "__VITE_ASSET__fbx6WIrl__"